import { FOCO_VISIVEL } from 'utils/foco';

import { formatarPontos } from '../extrato-modelo';

interface FaixaDoTotalProps {
  titulo: string;
  rotulo: string;
  cicloTitulo?: string;
  total: number;
  unidade: string;
  aviso?: string[];
}

/**
 * Faixa escura do total a creditar, com o aviso de pré-requisito quando houver (PREM-11, PREM-12).
 * O anel de foco fica fora da faixa, sobre o fundo claro da página: por isso é o azul-escuro, não o branco.
 */
export default function FaixaDoTotal({ titulo, rotulo, cicloTitulo, total, unidade, aviso }: FaixaDoTotalProps) {
  return (
    <div tabIndex={0} className={`mt-1.5 rounded-xl bg-brand-blue-dark px-5 py-[22px] text-brand-white sm:px-6 ${FOCO_VISIVEL}`}>
      <div className="flex flex-wrap items-center gap-x-[18px] gap-y-2">
        {/* Em tela estreita o número desce para baixo do título, em vez de espremê-lo. */}
        <div className="min-w-[200px] flex-1">
          {/* Como no design, o título de 15px fica numa linha de 16px: é ela que dá a altura. */}
          <h3 className="m-0 text-[16px] font-normal leading-[normal]">
            <span className="font-display text-[15px] font-bold">{titulo}</span>
          </h3>
          <p className="m-0 mt-1.5 text-[12px] text-white/80">
            {rotulo} · Ciclo {cicloTitulo}
          </p>
        </div>
        <p className="m-0 flex shrink-0 items-baseline gap-2">
          <span className="font-display text-[32px] font-extrabold text-brand-yellow">{formatarPontos(total)}</span>
          <span className="text-[13px]">{unidade}</span>
        </p>
      </div>
      {aviso && (
        <div className="mt-5 border-t border-solid border-white/20 pt-5">
          {aviso.map(linha => (
            <p key={linha} className="m-0 text-[12px] leading-[1.6]">
              {linha}
            </p>
          ))}
        </div>
      )}
    </div>
  );
}
